import type { LucideIcon } from 'lucide-react';
import type { ButtonHTMLAttributes } from 'react';

interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  readonly icon: LucideIcon;
  readonly label: string;
  readonly badge?: string;
}

export function IconButton({ icon: Icon, label, badge, className = '', ...props }: IconButtonProps) {
  return (
    <button className={`icon-button ${className}`.trim()} type="button" aria-label={label} title={label} {...props}>
      <Icon aria-hidden="true" size={20} strokeWidth={1.9} />
      {badge ? <span className="icon-button__badge">{badge}</span> : null}
    </button>
  );
}
